<template>
  <div>
    <span id="product"></span>
    <div class="my-5 text-center" v-if="merchant.is_load">
      <loader />
    </div>
    <template v-else>
      <div class="my-4" v-if="merchant.error != ''">
        <ErrorMessage :message="merchant.error" />
      </div>
      <template v-else>
       

        <div class="position-relative z-index-1028">
          <div class="row no-gutters justify-content-center">
            <div class="fixed-top d-block nav-bottom">
              <div class="custom-container-fluid px-0">
                <div class="row justify-content-center no-gutters">
                  <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                    <div class="bg-green">
                      <div class="container px-4 w-100 pt-1 pb-2">
                        <div class="row no-gutters py-2 m-0 w-100">
                          <div class="col-1">
                            <div class="">
                              <router-link :to="'/'+getMerchant.code+'/concierge/experience/'+merchant_child_id">
                                <img src="../../../../assets/img/icon/back-white.png" class="mt-1" width="20">
                              </router-link>
                            </div>
                          </div>
                          <div class="col-11">
                            <div class="">
                              <p class="mb-0 body-1-2 nav-hotel ml-3 mt-1 text-white text-truncate">{{merchant.data.name}}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container mt-8 pt-3">
          <div class="row slim-grid-row">
            <div class="col-1">
              <img src="../../../../assets/img/icon/calendar-green.png" class="mt-2 ml-1" width="20">
            </div>
            <div class="col-11">
              <v-date-picker
                ref='calendar'
                v-model='filter_date'
                :min-date='tx_date_min'
                :popover="{ visibility: 'click' }"
                color='green'
                >
                <div class="row slim-grid-row">
                  <div class="col-7">
                    <div class="ml-2">
                      <p class="mb-0 text-green sub-heading-1-1">{{displayToday(visit_date)}}</p>
                      <p class="mb-0 body-3-3 color-black">{{dateIsToday(visit_date)}}</p>
                    </div>
                  </div>
                  <div class="col-5">
                    <p class="mb-0 text-green body-2-1 py-2 px-1 rounded-10 text-center" style="background-color: #EFEFEF">
                    {{$t('merchant.change-date')}}</p>
                  </div>
                </div>
              </v-date-picker>
            </div>
          </div>
        </div>
        <div class="break bg-green mt-2"></div>
        <loader v-if="product.is_load" />
        <div v-else class="container p-4">
          <div class="my-4 px-3" v-if="product.error != ''">
            <ErrorMessage :message="product.error" />
          </div>
          <template v-else>

            <ClaimingReward wrapper_class="mb-4"></ClaimingReward>
            
            <div class="w-100 mt-5 text-center" v-if="product.list.length == 0">
              <img src="../../../../assets/img/icon/namaste.png" width="250">
              <p class="pt-3 heading-4 text-22 mb-2">{{$t('hotel.concierge.fitur.experience.tickets-not-available')}}</p>
              <p class="body-2 mb-4 w-75 mx-auto">{{$t('hotel.concierge.fitur.experience.tickets-are-not-available-on')}} <span class="font-weight-bold">{{customFormatDateTime(filter_date)}}</span>. {{$t('hotel.concierge.fitur.experience.please-choose-another-date')}}</p>
            </div>
            <template v-for="item in product.list">
              <!-- <ticket :data="item"></ticket> -->
              <productExperience :data="item" :merchant="merchant.data"></productExperience>
            </template>
          </template>
        </div>
      </template>
    </template>
    <floatingCartExperience></floatingCartExperience>
    <!-- <BottomNavbar></BottomNavbar> -->
    <div v-if="getConciergeOrder.experience.cart.length > 0" style="height:75px"></div>
  </div>
</template>
<script>
  import {mapGetters, mapMutations} from "vuex";
  import {customFormatDateTime} from '@/utils/index.js';
  import {get} from '@/services/index.js';
  import moment from 'moment';
  import productExperience from '@/components/hotel/concierge/general/productExperience'
  import floatingCartExperience from '@/components/hotel/concierge/general/floatingCartExperience'
  import BottomNavbar from '@/components/hotel/BottomNavbar';
  import ClaimingReward from '@/components/hotel/general/ClaimingReward.vue';

  export default {
    components:{
      productExperience,
      floatingCartExperience,
      BottomNavbar,
      ClaimingReward
    },
    data() {
      return {
        product:{
          list: [],
          is_load: false,
          error: ''
        },
        merchant:{
          is_load: true,
          data: {},
          error: ''
        },
        filter_date: new Date(),
        temp_filter_date: new Date(),
        // tx_date: moment(this.getTicketCart().visit_date).toDate(),
        tx_date_min: new Date(),
        tx_date_max: moment().add(1,'d').toDate(),
        warning_merchant_notfound_show: false
      }
    },
    computed:{
      ...mapGetters([
        'getConciergeOrder',
        'getMerchant',
        'getMembershipRewardApplied',
        'isMembershipRewardApplied']),
      visit_date(){
        return this.getConciergeOrder.experience.date
      },
      merchant_child_id(){
        return this.$route.params.id
      }
    },
    watch:{
      filter_date(){
        if(!this.merchant.is_load){
          if(this.filter_date != null){
            if(this.getMerchant.id) {
              this.resetConciergeOrder()
              this.setConciergeOrderExperienceDate(this.filter_date);
              this.loadProductList()
            }
            this.temp_filter_date = this.filter_date
          }else{
            this.filter_date = moment(this.temp_filter_date).toDate()
          }
        }
      }
    },
    created(){
      this.$validateActiveReward('concierge-room-dining')
    },
    mounted(){
      document.getElementById('product').scrollIntoView({
          behavior: 'smooth'
      });
      this.loadFirstData()
    },
    methods:{
      // GENERAL
      ...mapMutations(['setConciergeOrderExperienceDate','resetConciergeOrder']),
      formatDate(date){
        return customFormatDateTime(date,null,'ddd, DD MMM YYYY')
      },
      displayToday(date){
        // check if date is today
        if (moment().isSame(moment(date),'day')) return this.$t('merchant.today')

        // else
        return customFormatDateTime(date,null,'dddd')
      },
      dateIsToday(date){
        // check if date is today
        if (moment().isSame(moment(date),'day')) return this.formatDate(date) 

        // else
        return customFormatDateTime(date,null,'DD MMM YYYY')
      },
      customFormatDateTime(date){
        return customFormatDateTime(date,null,'dddd, DD MMM YYYY')
      },
      changeVisitDate(e){
        this.ticketSetBookingDateCart(e.date);
      },
      checkAndFillDate(){
        let today = moment()
        let fltr_date = moment(this.visit_date)
        if(moment(fltr_date).isBefore(today)){
          this.setConciergeOrderExperienceDate(today);
        }
        let copied_data = JSON.parse(JSON.stringify(this.getConciergeOrder.experience))
        this.filter_date = moment(copied_data.date).toDate()
      },
      goToHome(){
        this.$router.push({
          path: '/'+this.getMerchant.code  
        })
      },
      stopLoadData(msg_merchant='',msg_product=''){
        this.merchant.is_load = false
        this.product.is_load = false
        this.merchant.error = msg_merchant
        this.product.error = msg_product
      },

      // API
      loadProductList(){
        return new Promise(done=>{
          this.product.is_load = true
          this.product.error = ''
          get("CONCIERGE","experience/merchant/"+this.merchant_child_id+"/product",{
            merchant_id: this.getMerchant.id,
            service_date: moment(this.getConciergeOrder.experience.date).format("YYYY-MM-DD"),
          	membership_reward_id: this.isMembershipRewardApplied ? this.getMembershipRewardApplied.id : ''
          }).then(response=>{
            let res = response.data
            if (res.success) {
              this.product.list = res.data
              this.product.is_load = false
              done(true)
            }else{
              this.product.error = res.message
              this.product.is_load = false
              done(res.message)
            }
          })
        })
      },
      loadMerchantData(){
        return new Promise(done=>{
          get("CONCIERGE","experience/merchant/"+this.merchant_child_id,{
            merchant_id: this.getMerchant.id
          }).then(response=>{
            let res = response.data
            if(res.success){
              this.merchant.data = res.data
              done(true)
            }else{
              done(res.message)
            }
          })
        })
      },
      loadFirstData(){
        this.merchant.is_load = true
        this.merchant.error = ''
        this.loadMerchantData().then(merchant_response=>{
          if(merchant_response == true){
            this.checkAndFillDate()
            this.loadProductList().then(product_res=>{
              if(product_res == true){
                this.stopLoadData()
              }else{
                this.stopLoadData('',product_res)
              }
            })
          }else{
            this.stopLoadData(merchant_response)
          }
        })
      }
    }
  }

</script>
<style scoped>
  .break {
    background-color: #e9ebf2;
    height: 6px;
    border-top: 1px solid #e2e2e2;
  }

  .color-black {
    color: #000 !important;
  }

  .color-bold-light {
    color: #000000A6;
  }

  .plus-min-set input {
    margin-top: 10px;
  }

@media only screen and (max-width: 321px){
    .counter{
      width: 25px !important;
    }
  }

  @media only screen and (min-width: 600px){
    .counter{
      text-align: right !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/hotel/concierge/thingstodo/ProductList.vue